/**
 * expand and contract rows that have attr [data-expandable]
 */
export default function expandableRows() {
  const rows = document.querySelectorAll('[data-expandable="true"]');
  rows.forEach((row) => {
    row.addEventListener('click', () => row.classList.toggle('pilot-row--expanded'));
  });
}



// WEBPACK FOOTER //
// local_static/templates/motor/2017/assets/scripts/expandableRows.js